"use client";

import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { CentralizedDrawer } from "@wtc/ui";

interface MessageDetailLoadingProps {
  shouldUseDrawer?: boolean;
  className?: string;
}

export function MessageDetailLoading({
  shouldUseDrawer = false,
  className,
}: MessageDetailLoadingProps) {
  const renderLoadingContent = () => (
    <div className="flex items-center justify-center py-16">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2" />
        <p className="text-sm text-muted-foreground">Loading message details...</p>
      </div>
    </div>
  );

  if (shouldUseDrawer) {
    return (
      <CentralizedDrawer
        drawerId="mobile-message-detail"
        side="bottom"
        height="90vh"
        className={className}
        title="Loading..."
        showCloseButton={true}
        enableSwipeGesture={true}
      >
        <div className="flex-1 overflow-y-auto p-4">{renderLoadingContent()}</div>
      </CentralizedDrawer>
    );
  }

  return (
    <div className={cn("flex h-full flex-col", className)}>
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center space-x-3">
          <div className="h-10 w-10 bg-muted animate-pulse rounded-full" />
          <div className="space-y-2">
            <div className="h-4 w-48 bg-muted animate-pulse rounded" />
            <div className="h-3 w-32 bg-muted animate-pulse rounded" />
          </div>
        </div>
      </div>
      <div className="flex-1">{renderLoadingContent()}</div>
    </div>
  );
}
